export function showModal(dialog: HTMLDialogElement) {
  if (!document.querySelector("dialog[open]")) {
    applyScrollbarPadding();
  }

  return new Promise<string>((resolve) => {
    const handleClick = function (event: MouseEvent) {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement)) {
        return;
      }

      dialog.close();

      event.preventDefault();
      event.stopPropagation();
    };

    dialog.addEventListener("click", handleClick);
    dialog.addEventListener(
      "close",
      function (event) {
        if (!document.querySelector("dialog[open]")) {
          revertScrollbarPadding();
        }

        dialog.removeEventListener("click", handleClick);

        resolve(dialog.returnValue);
      },
      { once: true },
    );

    dialog.addEventListener("click", handleClick);

    dialog.returnValue = "";
    dialog.showModal();
  });
}

let scrollbarWidthCache: number | undefined = undefined;

function applyScrollbarPadding() {
  if (typeof scrollbarWidthCache === "undefined") {
    scrollbarWidthCache = measureScrollbarWidth();
  }
  const scrollbarWidth = scrollbarWidthCache;

  const declaredValue = document.body.style.paddingRight;
  if (typeof declaredValue === "string" && declaredValue.length > 0) {
    document.body.dataset.previousPaddingRight = declaredValue;
  }

  const computedStyle = window.getComputedStyle(document.body);
  const paddingRight = computedStyle.paddingRight;
  if (paddingRight !== "0" && paddingRight !== "0px") {
    document.body.style.paddingRight = `calc(${paddingRight} + ${scrollbarWidth}px)`;
  } else {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }

  document.body.style.overflow = "hidden";
  document.body.style.touchAction = "none";
}

const revertScrollbarPadding = () => {
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("touch-action");

  const previousPaddingRight = document.body.dataset.previousPaddingRight;
  if (
    typeof previousPaddingRight === "string" &&
    previousPaddingRight.length > 0
  ) {
    document.body.style.paddingRight = previousPaddingRight;
    document.body.removeAttribute("data-previous-padding-right");
  } else {
    document.body.style.removeProperty("padding-right");
  }
};

function measureScrollbarWidth() {
  const div = document.createElement("div");
  div.style.position = "absolute";
  div.style.top = "-9999px";
  div.style.width = "50px";
  div.style.height = "50px";
  div.style.overflow = "scroll";

  document.body.appendChild(div);
  const width = div.getBoundingClientRect().width - div.clientWidth;
  document.body.removeChild(div);

  return width;
}
